module.exports = __webpack_public_path__ + "media/images/emblems/Wynigen-coat_of_arms-4883f93651cb0df636e0916bfec06d02.svg";